const de = {
  nav: {
    home: 'Startseite',
    about: 'Unternehmen',
    services: 'Leistungen',
    projects: 'Projekte',
    trust: 'Compliance',
    contact: 'Kontakt',
    partnerships: 'Partnerschaft',
    cta: 'Partnerschaftsgespräch anfragen',
    menu: 'Menü',
  },
  hero: {
    badge: 'B2B · DACH-Märkte · EU-bereit',
    headline: 'Solare Installationskapazität, die planbar ist.',
    subheadline:
      'Spanischer Installationssubunternehmer für EPCs, Solarunternehmen und Energieversorger in ganz Europa. Zwei strukturierte Teams. Planbare Kapazität. Vollständige Dokumentation.',
    cta_primary: 'Partnerschaftsgespräch anfragen',
    cta_secondary: 'Leistungen ansehen',
    image_caption: 'Vor-Ort-Ausführung · HSE-konform · Dokumentationsbereit',
  },
  metrics: {
    title: 'Betriebskapazität',
    subtitle: 'Kennzahlen für Projektplanung und Kapazitätszuweisung.',
    workers: { label: 'Installationsfachkräfte', value: '6' },
    teams: { label: 'Unabhängige Teams', value: '2' },
    capacity: { label: 'Tageskapazität', value: '~2' },
    capacity_unit: 'Installationen/Tag',
    experience: { label: 'Jahre in Betrieb', value: '5+' },
  },
  services: {
    title: 'Leistungen',
    subtitle: 'Vollständige Installationsleistungen für Solaranlagenbetreiber, EPCs und Energieunternehmen.',
    pv: {
      title: 'Wohngebäude-PV-Installationen',
      description:
        'Vollständige Wohngebäude-Solarinstallation von der Standortbewertung bis zur Inbetriebnahme. Koordination, Montage, Verdrahtung, Prüfung und Bestandsdokumentation inklusive.',
      badges: ['B2B', 'SLA-bereit', 'EU-Einsatz'],
      features: [
        'Teamplanung & Koordination',
        'Vor-Ort-Montage & Verdrahtung',
        'Inbetriebnahme & Prüfung',
        'Bestandsdokumentation',
      ],
    },
    ev: {
      title: 'Ladestation-Installationen',
      description:
        'Professionelle Installation von EV-Ladeinfrastruktur mit vollständiger Koordination, Prüfung und Übergabedokumentation. Geeignet für Mehrstandort-Rollout-Programme.',
      badges: ['B2B', 'Mehrstandort', 'Rollout-bereit'],
      features: [
        'Koordination mit Elektromeistern',
        'Infrastrukturinstallation',
        'Prüfung & Inbetriebnahme',
        'Technische Übergabedokumente',
      ],
    },
    repairs: {
      title: 'Reparatur & Störungsbeseitigung',
      description:
        'Schneller Vor-Ort-Einsatz bei Installationsfehlern und Systemstörungen. Strukturierte Fehleranalyse, Behebung und umfassende Fotodokumentation für Ihre Unterlagen.',
      badges: ['SLA-bereit', 'Schnelleinsatz', 'Dokumentiert'],
      features: [
        'Prioritätsmäßige Diagnose',
        'Vor-Ort-Reparatur',
        'Fotodokumentation',
        'Schriftliche Störungsberichte',
      ],
    },
    learn_more: 'Vollständige Leistungsübersicht',
  },
  why: {
    title: 'Warum mit uns arbeiten',
    subtitle:
      'Konzipiert für EPCs und Solaranlagenbetreiber, die einen zuverlässigen Installationspartner suchen.',
    principles: [
      {
        title: 'Zwei unabhängige Teams',
        desc: 'Parallele Installationsprogramme sind möglich. Zwei vollständig ausgerüstete Teams, die unabhängig voneinander an verschiedenen Standorten operieren.',
      },
      {
        title: 'Strukturierte Dokumentation',
        desc: 'Jede Installation umfasst Inbetriebnahmeprotokolle, Bestandsfotos, Checklisten und Übergabeberichte — einsatzbereit für Ihren Workflow.',
      },
      {
        title: 'EU-bereit und mobil',
        desc: 'Hauptsitz in der Comunidad Valenciana mit nachgewiesener Erfahrung in Madrid und Barcelona. Einsatz in Deutschland, Österreich, der Schweiz und der EU möglich.',
      },
      {
        title: 'Nachgewiesene Referenzen',
        desc: 'Subunternehmer-Erfahrung mit 1komma5°, Verne, EDP und Holaluz — Unternehmen mit hohen Qualitäts- und Dokumentationsstandards.',
      },
    ],
    accordion: [
      {
        title: 'HSE-Konformität',
        content:
          'Alle Teams arbeiten nach strengen Arbeitsschutzvorschriften. PSA-Anforderungen, Absturzsicherung und Arbeitssicherheitsdokumentation sind auf jeder Baustelle Standard.',
      },
      {
        title: 'Dokumentationsstandards',
        content:
          'Wir liefern vollständige Bestandsdokumentation: Installationsfotos, Inbetriebnahmeberichte, Stromlaufpläne (sofern zutreffend) und unterzeichnete Abnahmeprotokolle.',
      },
      {
        title: 'Ausrüstung und Werkzeug',
        content:
          'Die Teams sind mit professionellem Installationswerkzeug, Sicherheitsausrüstung und Prüfgeräten ausgestattet. Keine Abhängigkeit von kundenseitiger Ausrüstung.',
      },
    ],
  },
  partners: {
    title: 'Auftraggeber und Partner',
    subtitle: 'Wir waren als Installationssubunternehmer tätig für:',
  },
  gallery_preview: {
    title: 'Ausgewählte Projekte',
    subtitle: 'Eine Auswahl aktueller Wohn- und Gewerbeinstallationen.',
    view_all: 'Alle Projekte ansehen',
  },
  cta_section: {
    title: 'Bereit, Ihre Installationskapazität zu erweitern?',
    subtitle:
      'Sprechen Sie mit uns über Ihre Projekte in Spanien, Deutschland, Österreich oder der Schweiz. Wir können in der Regel innerhalb einer Woche mobilisieren.',
    cta: 'Partnerschaftsgespräch anfragen',
    secondary: 'oder schreiben Sie uns: info@energiesse.com',
  },
  about: {
    headline: 'Ein zuverlässiger Installationspartner, konzipiert für B2B-Betrieb.',
    intro:
      'ENERGIESSE SL ist ein spanischer Solarinstallations-Subunternehmer, spezialisiert auf Wohngebäude-PV-Systeme, EV-Ladestation-Installationen und schnelle Störungsbeseitigung. Wir arbeiten ausschließlich mit Solarunternehmen, EPCs und Energieversorgern zusammen.',
    team_title: 'Teamstruktur',
    team_subtitle:
      'Zwei unabhängige Installationsteams, die gleichzeitig an verschiedenen Standorten eingesetzt werden können.',
    team_1: {
      title: 'Installationsteam A',
      role: 'PV-Neuinstallationen',
      desc: 'Spezialisiertes Team für neue Wohngebäude-PV-Systeme. Vollständiger Zyklus: Standortbewertung, Montage, Verdrahtung, Inbetriebnahme und Dokumentation.',
    },
    team_2: {
      title: 'Installationsteam B',
      role: 'EV & Störungsbeseitigung',
      desc: 'Spezialisiertes Team für Ladestation-Installationen und schnelle Störungseinsätze. Paralleleinsatz mit Team A möglich.',
    },
    capacity_title: 'Betriebskapazität',
    capacity_items: [
      { label: 'Gesamtpersonal', value: '6 ausgebildete Fachkräfte' },
      { label: 'Teamstruktur', value: '2 unabhängige Teams à 3 Personen' },
      { label: 'Tagesdurchsatz', value: '~2 Wohngebäude-Installationen/Tag' },
      { label: 'Skalierbarkeit', value: 'Teams in verschiedenen Regionen einsetzbar' },
    ],
    geography_title: 'Geografische Abdeckung',
    geography_primary: 'Primärregion',
    geography_primary_value: 'Comunidad Valenciana, Spanien',
    geography_secondary: 'Etablierte Abdeckung',
    geography_secondary_value: 'Madrid, Barcelona',
    geography_international: 'Internationale Verfügbarkeit',
    geography_international_value: 'Deutschland, Österreich, Schweiz und weitere EU-Länder',
    compliance_title: 'Professionelle Positionierung',
    compliance_desc:
      'ENERGIESSE SL agiert ausschließlich als B2B-Installations-Subunternehmer. Wir sind kein Endkundenunternehmen. Unsere Dokumentationsstandards und kaufmännischen Konditionen sind auf professionelle Betreiber mit Mehrstandort-Installationsprogrammen ausgerichtet.',
    values_title: 'Unsere Betriebsprinzipien',
    values: [
      { title: 'Zuverlässigkeit', desc: 'Wir halten Terminzusagen ein. Bei Änderungen kommunizieren wir frühzeitig.' },
      { title: 'Dokumentation', desc: 'Jedes Projekt hinterlässt einen vollständigen Dokumentationsnachweis. Ausnahmslos.' },
      { title: 'Sicherheit', desc: 'HSE-Konformität ist kein Zusatz. Es ist unsere Basis auf jeder Baustelle.' },
      { title: 'Klarheit', desc: 'Klare Preise, klare Zeitpläne, klare Kommunikation. Keine Überraschungen.' },
    ],
  },
  services_page: {
    headline: 'Installationsleistungen für professionelle Betreiber.',
    subtitle: 'Drei Kernleistungsbereiche, konzipiert für B2B-Subunternehmer-Aufträge. SLA-bereit, dokumentiert und skalierbar.',
    pv: {
      headline: 'Wohngebäude-PV-Installationen',
      intro: 'Unsere Kernleistung. Vollständige Wohngebäude-Photovoltaik-Installation für EPCs und Solaranlagenbetreiber, die Rollout-Programme in Spanien und Europa durchführen.',
      scope: 'Leistungsumfang',
      scope_items: [
        'Standortbewertung und Vorabdokumentation',
        'Modulmon tage und Dachabsicherung',
        'DC-Verdrahtung und Stringkonfiguration',
        'Wechselrichterinstallation und AC-Anbindung',
        'Systemin betriebnahme und Leistungsverifikation',
        'Bestandsdokumentation und Übergabepaket',
      ],
      b2b_note: 'Wir fungieren als White-Label-Installationspartner. Die Übergabedokumentation kann für Ihren Kundenlieferworkflow gebrandmarkt werden.',
    },
    ev: {
      headline: 'Ladestation-Installationen',
      intro: 'Professionelle EV-Ladestation-Installation für Wohn- und Gewerbeimmobilien. Geeignet für Mehrstandort-Rollout-Programme mit einheitlicher Qualität und Dokumentation.',
      scope: 'Leistungsumfang',
      scope_items: [
        'Standortbesichtigung und Infrastrukturbewertung',
        'EVSE-Einheit und Wandmontage',
        'Kabelführung und Elektroanschluss',
        'Koordination mit zugelassenen Elektromeistern',
        'Prüfung, Lastverifizierung und Inbetriebnahme',
        'Vollständige Übergabedokumentation',
      ],
      b2b_note: 'Geeignet für Betreiber mit wiederkehrendem Installationsvolumen. Rahmenverträge möglich.',
    },
    repairs: {
      headline: 'Reparatur & Störungsbeseitigung',
      intro: 'Vor-Ort-Diagnose und Reparaturservice für PV- und EV-Ladesysteme. Strukturierter Einsatz für EPCs bei Garantieansprüchen, Kundeneskalationen oder Systemminderleistung.',
      scope: 'Leistungsumfang',
      scope_items: [
        'Priorisiertere Einsatzbuchung (in der Regel innerhalb von 48–72 Stunden)',
        'Vor-Ort-Diagnose und Ursachenanalyse',
        'Bauteilreparatur oder -austausch',
        'Leistungsverifikation nach Reparatur',
        'Foto- und Schriftbericht',
        'Eskalationsprotokoll für komplexe Störungen',
      ],
      b2b_note: 'Störungsberichte sind strukturiert für die direkte Einbindung in Ihre Kundenkommunikation und Garantieverfolgungssysteme.',
    },
    common: {
      b2b_badge: 'Nur B2B',
      geographic_note: 'Einsatzgebiet: Spanien (primär) · Deutschland, Österreich, Schweiz, EU (nach Vereinbarung)',
      contact_cta: 'Leistungsumfang besprechen',
    },
  },
  projects_page: {
    headline: 'Installationsportfolio',
    subtitle: 'Ausgewählte Wohn- und Gewerbeinstallationsprojekte. Alle Projekte als B2B-Subunternehmer durchgeführt.',
    filter_all: 'Alle',
    filter_pv: 'PV-Installationen',
    filter_ev: 'Ladestationen',
    filter_repairs: 'Reparaturen',
    before: 'Vorher',
    after: 'Nachher',
    video_placeholder: 'Installationsvideo — auf Anfrage erhältlich',
    projects: [
      { id: 'p1', title: 'Wohngebäude-PV — Valencia', type: 'pv', capacity: '6,5 kWp', panels: '13 Module', location: 'Comunidad Valenciana', year: '2024', client: 'EPC-Partner (vertraulich)', before_img: 'https://images.unsplash.com/photo-1605980776566-0486c3ac7617?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&q=80' },
      { id: 'p2', title: 'Wohngebäude-PV — Madrid', type: 'pv', capacity: '8,2 kWp', panels: '16 Module', location: 'Madrid', year: '2024', client: 'EPC-Partner (vertraulich)', before_img: 'https://images.unsplash.com/photo-1558449907-29a1048b85b9?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800&q=80' },
      { id: 'p3', title: 'Mehrfamilien-PV — Barcelona', type: 'pv', capacity: '24 kWp', panels: '48 Module', location: 'Barcelona', year: '2023', client: 'Solaranlagenbetreiber (vertraulich)', before_img: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800&q=80' },
      { id: 'p4', title: 'Ladestation-Installation — Valencia', type: 'ev', capacity: '11 kW', panels: '1 Einheit', location: 'Comunidad Valenciana', year: '2024', client: 'Energieversorger (vertraulich)', before_img: 'https://images.unsplash.com/photo-1593941707882-a5bba13c2e09?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80' },
      { id: 'p5', title: 'Störungseinsatz — Madrid', type: 'repairs', capacity: '5,5 kWp', panels: '11 Module', location: 'Madrid', year: '2023', client: 'EPC-Partner (vertraulich)', before_img: 'https://images.unsplash.com/photo-1595437193398-f24279553f4f?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1564151436289-8fc3f8ea6326?w=800&q=80' },
      { id: 'p6', title: 'Wohngebäude-PV groß — Valencia', type: 'pv', capacity: '12 kWp', panels: '24 Module', location: 'Comunidad Valenciana', year: '2024', client: 'Solaranlagenbetreiber (vertraulich)', before_img: 'https://images.unsplash.com/photo-1548348384-a1069e9d4179?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1552197892-f2ad2f75e7c8?w=800&q=80' },
    ],
  },
  trust: {
    headline: 'Compliance & Nachweise',
    subtitle: 'Rechtsstatus, Versicherungsschutz und Berufsqualifikationen — verfügbar für Partner-Due-Diligence.',
    legal_title: 'Rechtseinheit',
    legal_fields: [
      { label: 'Unternehmensname', value: 'ENERGIESSE SL' },
      { label: 'Rechtsform', value: 'Sociedad Limitada (SL)' },
      { label: 'CIF / USt-IdNr.', value: 'Auf Anfrage erhältlich' },
      { label: 'Eingetragener Sitz', value: 'Comunidad Valenciana, Spanien' },
      { label: 'Domain', value: 'energiesse.com' },
      { label: 'Primärkontakt', value: 'info@energiesse.com' },
    ],
    insurance_title: 'Versicherungsschutz',
    insurance_items: [
      { label: 'Betriebshaftpflichtversicherung', status: 'Aktiv', detail: 'Deckung für Drittschäden bei Vor-Ort-Einsätzen' },
      { label: 'Berufshaftpflichtversicherung', status: 'Aktiv', detail: 'Deckung für Installationsfehler' },
      { label: 'Arbeitsunfallversicherung', status: 'Aktiv', detail: 'Vollständige Deckung für alle Teammitglieder' },
    ],
    cert_title: 'Zertifizierungen & Schulungen',
    cert_items: [
      { label: 'Photovoltaik-Installateur-Zertifizierung', status: 'Aktuell', issuer: 'Spanische Behörde für erneuerbare Energien' },
      { label: 'EV-Ladestation-Qualifikation', status: 'Aktuell', issuer: 'Akkreditierter Ausbildungsanbieter' },
      { label: 'Niederspannungsinstallation', status: 'Aktuell', issuer: 'Spanische Elektrobehörde' },
      { label: 'HSE / Arbeitssicherheitsschulung', status: 'Aktuell', issuer: 'Berufsgenossenschaft' },
    ],
    safety_title: 'Sicherheitsstandards',
    safety_desc:
      'Alle Installationsteams arbeiten nach strengen HSE-Protokollen. Sicherheitsdokumentation, PSA-Konformität und Absturzsicherungsmaßnahmen werden auf jeder Baustelle konsequent umgesetzt, unabhängig von Größe oder Dauer. Sicherheitsnachweise auf Anfrage erhältlich.',
    docs_title: 'Dokumentationslieferungen',
    docs_intro: 'Jedes abgeschlossene Projekt erzeugt folgendes Dokumentationspaket:',
    docs_items: [
      'Inbetriebnahmeprotokoll (unterzeichnet)',
      'Bestandsfotodokumentation',
      'Elektrischer Stromlaufplan (sofern zutreffend)',
      'Kundenabnahme-Checkliste',
      'Störungs- oder Abweichungsbericht (sofern zutreffend)',
    ],
    request_docs: 'Compliance-Unterlagen anfordern',
    request_docs_note: 'Versicherungszertifikate und Qualifikationsnachweise auf Anfrage nach NDA-Unterzeichnung oder für vorqualifizierte Partner.',
    active: 'Aktiv',
    current: 'Aktuell',
  },
  contact: {
    headline: 'Partnerschaftsgespräch anfragen',
    subtitle:
      'Teilen Sie uns Ihren Installationsbedarf mit. Wir antworten auf alle B2B-Anfragen innerhalb eines Werktages.',
    email_label: 'Direktkontakt',
    email_value: 'info@energiesse.com',
    response_note: 'Antwort innerhalb von 1 Werktag',
    form_title: 'Partnerschaftsanfrage',
    form_company: 'Unternehmensname',
    form_company_placeholder: 'Ihr Unternehmensname',
    form_name: 'Ansprechpartner',
    form_name_placeholder: 'Ihr vollständiger Name',
    form_email: 'Geschäftliche E-Mail',
    form_email_placeholder: 'sie@unternehmen.de',
    form_phone: 'Telefon (optional)',
    form_phone_placeholder: '+49 ...',
    form_country: 'Land',
    form_country_placeholder: 'Land auswählen',
    form_project_type: 'Projektart',
    form_project_type_placeholder: 'Projektart auswählen',
    form_message: 'Was benötigen Sie von einem Installationspartner?',
    form_message_placeholder:
      'Beschreiben Sie Ihr Installationsprogramm: Volumen, Regionen, Zeitplan und besondere Anforderungen.',
    form_consent:
      'Ich bestätige, dass es sich um eine B2B-Anfrage handelt, und stimme der Kontaktaufnahme zu.',
    form_submit: 'Partnerschaftsgespräch anfragen',
    form_success_title: 'Anfrage eingegangen',
    form_success:
      'Vielen Dank. Wir haben Ihre Anfrage erhalten und melden uns innerhalb eines Werktages.',
    form_error:
      'Bei der Übermittlung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt unter info@energiesse.com.',
    project_types: [
      'Wohngebäude-PV-Rollout',
      'Ladestation-Rollout',
      'Reparatur & Wartungsprogramm',
      'Gemischt / noch zu besprechen',
    ],
    countries: [
      'Deutschland',
      'Österreich',
      'Schweiz',
      'Spanien',
      'Anderes EU-Land',
    ],
    validation: {
      company_required: 'Unternehmensname ist erforderlich',
      name_required: 'Name des Ansprechpartners ist erforderlich',
      email_required: 'Geschäftliche E-Mail ist erforderlich',
      email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      country_required: 'Bitte wählen Sie Ihr Land',
      project_type_required: 'Bitte wählen Sie eine Projektart',
      message_required: 'Bitte beschreiben Sie Ihren Bedarf',
      consent_required: 'Zustimmung ist erforderlich',
    },
  },
  partnerships: {
    headline: 'Partnerschaft mit ENERGIESSE SL',
    subtitle:
      'Wir suchen aktiv nach Subunternehmer- und Partnerschaftsvereinbarungen mit Solarinstallateuren, EPCs und Energieversorgern in Deutschland, Österreich und der Schweiz.',
    offer_title: 'Was wir als Subunternehmer bieten',
    offer_items: [
      {
        title: 'Dedizierte Installationskapazität',
        desc: 'Reservieren Sie Installationskapazität für Ihre Projektpipeline. Zwei unabhängige Teams für parallele Zeitplanung und Mehrstandort-Umsetzung.',
      },
      {
        title: 'Vollständige Übergabedokumentation',
        desc: 'Jedes Projekt umfasst Inbetriebnahmeberichte, Bestandsfotos und Abnahmeprotokolle — bereit für Ihren Lieferworkflow.',
      },
      {
        title: 'EU-Mobilität und Flexibilität',
        desc: 'Hauptsitz in Spanien, verfügbar in ganz Europa. Einsatz in Deutschland, Österreich, Schweiz und weiteren EU-Ländern mit kurzen Vorlaufzeiten.',
      },
      {
        title: 'Nachgewiesene Zuverlässigkeit',
        desc: 'Referenzerfahrung mit 1komma5°, Verne, EDP und Holaluz. Wir kennen die Qualitäts- und Dokumentationsstandards großer Betreiber.',
      },
    ],
    process_title: 'Wie eine Partnerschaft funktioniert',
    process_steps: [
      { step: '01', title: 'Erstgespräch', desc: 'Wir besprechen Ihre Projektpipeline, Kapazitätsbedarf, Regionen und Zeitplan. Keine Verpflichtung.' },
      { step: '02', title: 'Angebot', desc: 'Wir erstellen ein Kapazitäts- und Kalkulationsangebot für Ihr Programm. In der Regel innerhalb von 2 Werktagen.' },
      { step: '03', title: 'Vereinbarung', desc: 'Wir schließen einen Subunternehmervertrag oder Rahmenvertrag ab, der Leistungsumfang, Vergütung, Dokumentation und SLAs regelt.' },
      { step: '04', title: 'Erster Einsatz', desc: 'Teams werden für Ihre ersten Projekte mobilisiert. Dokumentation wird nach Abschluss geliefert. Leistungsreview nach dem Piloteinsatz.' },
    ],
    requirements_title: 'Ideales Partnerprofil',
    requirements_items: [
      'Solar-EPC oder Installationsunternehmen im DACH-Raum oder Spanien',
      'Projektpipeline von 5+ Installationen pro Monat oder wiederkehrendes Programm',
      'Benötigt zuverlässige Dokumentation und White-Label-Installationslieferung',
      'Schätzt Schnelligkeit, Konsistenz und klare Kommunikation',
    ],
    cta_title: 'Gespräch beginnen',
    cta_subtitle: 'Senden Sie uns Ihren Bedarf. Wir antworten innerhalb eines Werktages.',
    cta: 'Partnerschaftsgespräch anfragen',
    faq_title: 'Häufig gestellte Fragen',
    faqs: [
      {
        q: 'Arbeiten Sie auch außerhalb Spaniens?',
        a: 'Ja. Unser Haupteinsatzgebiet ist die Comunidad Valenciana, mit Erfahrung in Madrid und Barcelona. Wir sind für internationale Projekte in Deutschland, Österreich, der Schweiz und weiteren EU-Ländern verfügbar.',
      },
      {
        q: 'Können Sie hohe Installationsvolumen bewältigen?',
        a: 'Unsere Standardkapazität beträgt etwa 2 Wohngebäude-Installationen pro Tag mit unseren zwei Teams. Für höhere Volumen oder zeitkritische Programme besprechen wir Kapazitätsskalierung.',
      },
      {
        q: 'Welche Dokumentation liefern Sie?',
        a: 'Jede abgeschlossene Installation umfasst: Inbetriebnahmeprotokoll, Bestandsfotos, Stromlaufpläne (sofern zutreffend) und unterzeichnete Abnahmeprotokolle. Berichte können für Ihren Lieferworkflow formatiert werden.',
      },
      {
        q: 'Arbeiten Sie als White-Label-Partner?',
        a: 'Ja. Wir agieren auf Wunsch als stiller Subunternehmer. Dokumentation, Arbeitskleidung und Kommunikation können auf Ihre Markenanforderungen abgestimmt werden.',
      },
    ],
  },
  footer: {
    company: 'ENERGIESSE SL',
    domain: 'energiesse.com',
    email: 'info@energiesse.com',
    tagline: 'B2B-Solarinstallations-Subunternehmer · Spanien · EU',
    legal: 'Impressum',
    privacy: 'Datenschutz',
    rights: 'Alle Rechte vorbehalten.',
    nav_title: 'Navigation',
    contact_title: 'Kontakt',
    legal_title: 'Rechtliches',
    address: 'Comunidad Valenciana, Spanien',
  },
  language_changed: 'Sprache auf Deutsch eingestellt',
  common: {
    loading: 'Wird gesendet...',
    back: 'Zurück',
    read_more: 'Mehr erfahren',
    close: 'Schließen',
  },
};

export default de;
